import { IconFilterX } from "@tabler/icons-react"

import { Button } from "../../Button"
import { Tooltip } from "../../Tooltip"
import { LE_TableInstance } from "../types"

const CLEAR_FILTERS_BUTTON_ID_SUFFIX = "clear-filters-button"

export function ClearFiltersButton<T extends Record<string, any> = object>({
  table,
}: {
  table: LE_TableInstance<T>
}) {
  return (
    <Tooltip content="Clear all filters" dark>
      <Button
        id={table.getElementId(CLEAR_FILTERS_BUTTON_ID_SUFFIX)}
        variant="neutral"
        onClick={() => table.setColumnFilters([])}
        icon={IconFilterX}
        iconOnly
        className="h-fit"
      />
    </Tooltip>
  )
}
